import { DeviceInfo, isVersionGreaterOrEqualThan } from '@djs';
import { envs } from '../../core';
import { PwaPage } from './enums';

const PWA_WITH_PUSH_SUPPORTED_FROM_IOS = '16.4';
const SAFARI_REDISIGN_IOS_26 = '26.0';
const SAFARI_REDISIGN_IOS_27 = '27.0';
const PWA_INSTALL_SUPPORTED_FROM_CHROME_VERSION = '115.0.5790.84'; // https://jetstream.buzz/archives/173881

export function getPageKey(deviceInfo: DeviceInfo): PwaPage {
  const { mobileOS, browser } = deviceInfo;

  if (!mobileOS) {
    return PwaPage.InstallDesktop;
  }

  if (mobileOS.name === 'android') {
    return PwaPage.DisabledAndroid;
  }

  if (envs.APP_STORE_URL) {
    return PwaPage.DisabledIos;
  }

  if (!isVersionGreaterOrEqualThan(mobileOS.version, PWA_WITH_PUSH_SUPPORTED_FROM_IOS)) {
    return PwaPage.InstallUnavailableOnOldIos;
  }

  switch (browser.name) {
    case 'yandex':
      return PwaPage.InstallYandex;
    case 'chrome':
      return isVersionGreaterOrEqualThan(browser.version, PWA_INSTALL_SUPPORTED_FROM_CHROME_VERSION)
        ? PwaPage.InstallChrome
        : PwaPage.InstallOther;
    case 'safari':
      return isVersionGreaterOrEqualThan(mobileOS.version, SAFARI_REDISIGN_IOS_27)
        ? PwaPage.InstallSafariIos27
        : isVersionGreaterOrEqualThan(mobileOS.version, SAFARI_REDISIGN_IOS_26)
          ? PwaPage.InstallSafariIos26
          : PwaPage.InstallOldSafari;
    default:
      return PwaPage.InstallOther;
  }
}
